export const RELEASE_TYPES = [
  { value: 'single', label: 'Singolo (1-3 tracce)' },
  { value: 'ep', label: 'EP (4-6 tracce)' },
  { value: 'album', label: 'Album (7-30 tracce)' },
];

export const LANGUAGES = ['Italiano','English','Español','Français','Deutsch','Português','Japanese','Korean','Arabic','Hindi','Russian','Chinese','Strumentale','Multilingue'];

export const CONTRIBUTOR_ROLES = [
  { value: 'author_composer', label: 'Autore/Compositore *' },
  { value: 'author', label: 'Autore' },
  { value: 'composer', label: 'Compositore' },
  { value: 'vocalist', label: 'Interprete/Voci *' },
  { value: 'producer', label: 'Produttore *' },
  { value: 'arranger', label: 'Arrangiatore' },
  { value: 'musician', label: 'Musicista' },
  { value: 'mixer', label: 'Mixer' },
  { value: 'mastering_engineer', label: 'Mastering Eng.' },
  { value: 'sound_engineer', label: 'Fonico' },
  { value: 'artistic_director', label: 'Dir. Artistico' },
  { value: 'other', label: 'Altro' },
];

export const ARTIST_ROLES = [
  { value: 'primary', label: 'Principale' },
  { value: 'featuring', label: 'Feat.' },
  { value: 'remixer', label: 'Remixer' },
];

export const WORK_TYPES = [
  { value: '', label: '— Seleziona tipo lavoro —' },
  { value: 'original', label: 'Lavoro Originale' },
  { value: 'cover', label: 'Cover' },
  { value: 'public_domain', label: 'Pubblico Dominio' },
];

export function makeDefaultContributors() {
  return [
    { name: '', role: 'author_composer' },
    { name: '', role: 'vocalist' },
    { name: '', role: 'producer' },
  ];
}

export function makeDefaultArtists() {
  return [{ name: '', role: 'primary', artist_id: '' }];
}
